import React from 'react'
import { useLocation, Navigate } from "react-router-dom"
//import { useUser } from "../../services/StateContext"
import { usePatient } from 'Components/usePatientContext'
import { isValidCPF } from 'services/utils'

function Auth({ children }) {

    const { patient } = usePatient()
    const location = useLocation()

    const isAuth = isValidCPF(patient?.cpfPaciente)
    
    if (!isAuth) {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        return <Navigate to="/" state={{ from: location }} replace />
    }
  
    return children
}

export default Auth